const getters = {
  gridList(state) {
    return state.gridList;
  },
  plan(state) {
    return state.plan;
  },
  categoryNames(state) {
    return state.categoryNames;
  },
  searchQuery(state) {
    return state.searchQuery;
  },
  tblLoader(state) {
    return state.tblLoader;
  },
  sortBy(state) {
    return state.sortBy;
  },
  sortOrder(state) {
    return state.sortOrder;
  },
  isLoading(state) {
    return state.isLoading;
  },
  selectedSiteId(state) {
    return state.selectedSiteId;
  }
};

export default getters;
